const ActionType = require("action-types/promocodes");
const SnackbarActions = require("./snackbar");
const WebClient = require("utils/web-client");
const Deeply = require("utils/deeply");
const History = require("wiring/history");

const actions = exports;

exports.addPromoCodeBegin = () => {
    return {
        type: ActionType.ADD_PROMOCODE_BEGIN
    };
};

exports.addPromoCodeFailure = () => {
    return {
        type: ActionType.ADD_PROMOCODE_FAILURE
    };
};

exports.addPromoCodeSuccess = promo => {
    return {
        type: ActionType.ADD_PROMOCODE_SUCCESS,
        payload: { promo }
    };
};

exports.addPromoCode = promo => {
    return dispatch => {
        dispatch(actions.addPromoCodeBegin());

        const payload = Deeply(promo).value();
        payload.startDate = payload.startDate
            ? payload.startDate.format()
            : null;
        payload.endDate = payload.endDate ? payload.endDate.format() : null;

        return WebClient.post("/promocodes", payload)
            .then(({ data }) => {
                History.push("/admin/promocodes");
                dispatch(actions.addPromoCodeSuccess(data));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Created promo " + payload.code + " successfully"
                    )
                );
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.addPromoCodeFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};

exports.deletePromoCodeBegin = () => {
    return {
        type: ActionType.DELETE_PROMOCODE_BEGIN
    };
};

exports.deletePromoCodeFailure = () => {
    return {
        type: ActionType.DELETE_PROMOCODE_FAILURE
    };
};

exports.deletePromoCodeSuccess = () => {
    return {
        type: ActionType.DELETE_PROMOCODE_SUCCESS
    };
};

exports.deletePromoCode = id => {
    return dispatch => {
        dispatch(actions.deletePromoCodeBegin());

        return WebClient.delete("/promocodes/" + id)
            .then(({ data }) => {
                History.push("/admin/promocodes");
                dispatch(actions.deletePromoCodeSuccess(data));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Promocode deleted successfully"
                    )
                );
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.deletePromoCodeFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};

exports.fetchPromoCodesBegin = () => {
    return {
        type: ActionType.FETCH_PROMOCODES_BEGIN
    };
};

exports.fetchPromoCodesFailure = () => {
    return {
        type: ActionType.FETCH_PROMOCODES_FAILURE
    };
};

exports.fetchPromoCodesSuccess = items => {
    return {
        type: ActionType.FETCH_PROMOCODES_SUCCESS,
        payload: { items }
    };
};

exports.fetchPromoCodes = () => {
    return dispatch => {
        dispatch(actions.fetchPromoCodesBegin());

        return WebClient.get("/promocodes")
            .then(({ data }) => {
                dispatch(actions.fetchPromoCodesSuccess(data));
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.fetchPromoCodesFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};

exports.fetchSinglePromoCodeBegin = () => {
    return {
        type: ActionType.FETCH_SINGLE_PROMOCODE_BEGIN
    };
};

exports.fetchSinglePromoCodeFailure = () => {
    return {
        type: ActionType.FETCH_SINGLE_PROMOCODE_FAILURE
    };
};

exports.fetchSinglePromoCodeSuccess = promo => {
    return {
        type: ActionType.FETCH_SINGLE_PROMOCODE_SUCCESS,
        payload: { promo }
    };
};

exports.fetchSinglePromoCode = id => {
    return dispatch => {
        dispatch(actions.fetchSinglePromoCodeBegin());

        return WebClient.get("/promocodes/" + id)
            .then(({ data }) => {
                dispatch(actions.fetchSinglePromoCodeSuccess(data));
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.fetchSinglePromoCodeFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};

exports.updatePromoCodeBegin = () => {
    return {
        type: ActionType.UPDATE_PROMOCODE_BEGIN
    };
};

exports.updatePromoCodeFailure = () => {
    return {
        type: ActionType.UPDATE_PROMOCODE_FAILURE
    };
};

exports.updatePromoCodeSuccess = promo => {
    return {
        type: ActionType.UPDATE_PROMOCODE_SUCCESS,
        payload: { promo }
    };
};

exports.updatePromoCode = promo => {
    return dispatch => {
        dispatch(actions.updatePromoCodeBegin());

        const payload = Deeply(promo)
            .del("id")
            .value();
        payload.startDate = payload.startDate
            ? payload.startDate.format()
            : null;
        payload.endDate = payload.endDate ? payload.endDate.format() : null;

        return WebClient.patch("/promocodes/" + promo.id, payload)
            .then(({ data }) => {
                dispatch(actions.updatePromoCodeSuccess(data));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Promocode updated successfully"
                    )
                );
            })
            .catch(error => {
                console.error(error);
                dispatch(actions.updatePromoCodeFailure());
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/promocodes.js